import { FC } from 'react'
import TrashIcon from '@rsuite/icons/Trash'
import RemindIcon from '@rsuite/icons/RemindRound'
import InfoIcon from '@rsuite/icons/InfoRound'
import { Button, Modal } from 'shared'
import './ConfirmDialog.scss'

interface Props {
  open: boolean
  title: string
  message: React.ReactNode
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  onCancel: () => void
  loading?: boolean
  type?: 'danger' | 'warning' | 'info'
  /** Optional icon component to show in the badge, overriding the type default
   *  (e.g. a sign-out icon for a logout confirm). Falls back to the type icon. */
  icon?: React.ComponentType<any>
}

// Icon shown in the circular badge, chosen by dialog type.
const TYPE_ICON = {
  danger: TrashIcon,
  warning: RemindIcon,
  info: InfoIcon
}

const ConfirmDialog: FC<Props> = ({
  open,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  loading = false,
  type = 'danger',
  icon
}) => {
  const BadgeIcon = icon ?? TYPE_ICON[type]
  return (
    <Modal
      open={open}
      size="xs"
      className={`confirm-dialog confirm-dialog--${type}`}
      onClose={onCancel}
      body={
        <div className="confirm-dialog__content">
          <div className="confirm-dialog__icon">
            <BadgeIcon />
          </div>

          <h3 className="confirm-dialog__title">{title}</h3>
          <p className="confirm-dialog__message">{message}</p>

          <div className="confirm-dialog__actions">
            <Button
              type="button"
              className="confirm-dialog__cancel"
              onClick={onCancel}
              disabled={loading}
            >
              {cancelText}
            </Button>
            <Button
              type="button"
              className="confirm-dialog__confirm"
              onClick={onConfirm}
              loading={loading}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      }
    />
  )
}

export default ConfirmDialog
